var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tutor.certified)?_c('div',{staticClass:"flex flex-col leading-tight"},[_c('span',[_vm._v("Certified")]),_c('span',{domProps:{"textContent":_vm._s(_vm.tutor.certification_type)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }